/**
 * Anonymous User ID Utility
 * 
 * Generates and stores an anonymous UUID for user identification.
 * Used to enforce "one vote per question" rule in Q&A feature.
 */

const ANONYMOUS_USER_ID_KEY = 'wedding_anonymous_user_id';

/**
 * Generate a UUID v4
 * @returns {string} UUID v4 string
 */
function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * Get or create anonymous user ID
 * Returns existing ID from localStorage if present, otherwise generates a new one
 * @returns {string} Anonymous user ID (UUID)
 */
export const getAnonymousUserId = () => {
  try {
    let userId = localStorage.getItem(ANONYMOUS_USER_ID_KEY);
    
    if (!userId) {
      // Generate new UUID
      userId = generateUUID();
      localStorage.setItem(ANONYMOUS_USER_ID_KEY, userId);
    }
    
    return userId;
  } catch (error) {
    console.error('Failed to get/create anonymous user ID:', error);
    // Fallback: generate a temporary ID (won't persist across sessions)
    return generateUUID();
  }
};

/**
 * Clear anonymous user ID (for testing/debugging)
 */
export const clearAnonymousUserId = () => {
  try {
    localStorage.removeItem(ANONYMOUS_USER_ID_KEY);
  } catch (error) {
    console.error('Failed to clear anonymous user ID:', error);
  }
};
